import React from 'react';
import { Link } from "react-router-dom";
import {CustomHistogram} from './CustomHistogram';
import {CustomBoxplot} from './CustomBoxplot';
import ReactDOM from "react-dom/client";

import * as d3 from "d3";
import Barchart from "../2AFC/component/barchart";
import OutlierTable from "./OutlierTable";

class PartDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data,
            partIndex: props.partIndex,
            showChart: (props.data.pinnedOutlier || props.data.pinnedHistogram || props.data.pinnedBoxplot || props.data.pinnedTwoAfc)
        };
        // bind renders
        this.renderOutlier = this.renderOutlier.bind(this);
        this.renderHistogram = this.renderHistogram.bind(this);
        this.renderBoxplot = this.renderBoxplot.bind(this);
        this.renderTwoAfc = this.renderTwoAfc.bind(this);
        this.twoAfcRoot = null;
    }

    componentDidMount() {
        this.renderPinnedChart();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.data !== this.state.data) {
            this.renderPinnedChart();
        }
    }

    renderOutlier() {
        const outlierData = this.state.data.pinnedOutlier.outlierData;
        if (!outlierData) return;

        const containerId = "dashboardGraph" + this.state.partIndex;
        const container = document.getElementById(containerId);
        if (!container) return;

        if (!this.outlierRoot) {
            this.outlierRoot = ReactDOM.createRoot(container);
        }

        this.outlierRoot.render(
            <OutlierTable outlierData={outlierData} jwtToken={this.state.jwtToken} handleUpdate={this.props.handleUpdate} full={false} />
        );
    }


    renderHistogram() {
        var parsedData = [];
        if (this.state.data.pinnedHistogram.variableType === "DOUBLE") {
            parsedData = this.state.data.pinnedHistogram.doubleData;
        } else if (this.state.data.pinnedHistogram.variableType === "LONG"){
            parsedData = this.state.data.pinnedHistogram.longData;
        } else if (this.state.data.pinnedHistogram.variableType === "STRING"){
            parsedData = this.state.data.pinnedHistogram.stringData;
        }
        var histogram = CustomHistogram(parsedData, {
            width: 300,
            height: 160,
            margin: {top:40, bottom:20, left:70, right:20},
            legendRectWidth: 30,
            legendRectHeight: 15,
            legendRectMarginRight: 10,
            barLegendMarginTop: 11,
            labelTextSize: "14px",
            barLegend: this.state.data.pinnedHistogram.variable,
            xAxisSteps: this.state.data.pinnedHistogram.step,
            xAxisBars: this.state.data.pinnedHistogram.bars,
            xAxisMin: this.state.data.pinnedHistogram.min,
            xAxisMax: this.state.data.pinnedHistogram.max,
            isStringData: this.state.data.pinnedHistogram.variableType === "STRING"
        });

        d3.select("#dashboardGraph" + this.state.partIndex).html(histogram.outerHTML);
    }

    renderBoxplot () {
        let boxplot = CustomBoxplot(this.state.data.pinnedBoxplot.boxplotData, {
            width: 300,
            height: 160,
            margin: {top:40, bottom:20, left:70, right:20},
            legendRectWidth: 30,
            legendRectHeight: 15,
            legendRectMarginRight: 10,
            barLegendMarginTop: 11,
            labelTextSize: "14px",
            barLegend: this.state.data.pinnedBoxplot.targetVariable,
            xAxisLegend: this.state.data.pinnedBoxplot.filterVariable
        });

        d3.select("#dashboardGraph" + this.state.partIndex).html(boxplot.outerHTML);
    }

    renderTwoAfc() {
        const twoAfcData = this.state.data.pinnedTwoAfc;
        if (!twoAfcData) return;

        const containerId = "dashboardGraph" + this.state.partIndex;
        const container = document.getElementById(containerId);
        if (!container) return;

        if (!this.twoAfcRoot) {
            this.twoAfcRoot = ReactDOM.createRoot(container);
        }

        const bt = (
            <Barchart
                data={twoAfcData}
                modelType="BT"
            />
        );

        const tm = (
            <Barchart
                data={twoAfcData}
                modelType="TM"
            />
        );

        this.twoAfcRoot.render(
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                {bt}
                {tm}
            </div>
        );
    }

    renderPinnedChart() {
        if (this.state.data.pinnedOutlier){
            this.renderOutlier();
        } else if (this.state.data.pinnedHistogram){
            this.renderHistogram();
        } else if (this.state.data.pinnedBoxplot){
            this.renderBoxplot();
        } else if (this.state.data.pinnedTwoAfc){
            this.renderTwoAfc();
        }
    }

    render() {
        var varNames = [];
        if (typeof this.state.data.variables !==  "undefined"){
            for (var i = 0; i < this.state.data.variables.length; i++) {
                varNames.push( this.state.data.variables[i].name );
            }
        }
        var varNamesStr = JSON.stringify(varNames).replaceAll('","', ', ').replaceAll('"', ' ');

        return (
            <>
                <div style={{ width: "30%", marginLeft: "20px", marginRight: "20px", marginBottom: "20px", minWidth: 0 }}>
                    <table style={{ border: "1px solid lightgrey", width: "100%", tableLayout: "fixed" }} className="table table-hover">
                        <thead>
                        <tr style={{ backgroundColor: "lightgrey"}}>
                            <th>
                                <Link to={"/detail/part/" + this.state.data.id}>
                                    <span title="View statistic graphs for this part">{this.state.data.name}</span>
                                </Link>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td style={{ border:"none", paddingBottom: "20px"}}>
                                <p className="small">{this.state.data.description}</p>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ border:"none"}}><b>Variables: </b>{varNamesStr}</td>
                        </tr>
                        <tr>
                            <td style={{ border:"none"}}><b>Design type: </b>{this.state.data.designType}</td>
                        </tr>
                        <tr>
                            <td style={{ border:"none"}}><b>Repetition count: </b>{this.state.data.repetitionCount}</td>
                        </tr>
                        <tr>
                            <td style={{ border:"none", paddingTop: "20px"}}><b>Access token: </b>{this.state.data.accessToken}</td>
                        </tr>
                        { this.state.showChart ?
                            <tr>
                                <td style={{ border:"none", paddingTop: "20px"}}>
                                <div id={"dashboardGraph" + this.state.partIndex} style={{ overflowX: "auto" }} />
                            </td>
                            </tr>
                          : <></>
                        }
                    </tbody>
                </table>
            </div>
        </>
        );
    }
}

export default PartDetail;